<template>
  <div class="desc_modal_wrapper">
    <base-model
      class="enterprice_account"
      @closeModel="$emit('close')"
      :show="handelModalApperance"
    >
      <div class="comments">
        <h2 class="mb-7 mt-3">{{ title }}</h2>
        <div>
          <div class="comment_card">
            <p v-html="desc"></p>
          </div>
        </div>
      </div>
    </base-model>
  </div>
</template>

<script>
import BaseModel from "@/components/UI/BaseModel.vue";

export default {
  name: "DescriptionModal",

  components: {
    BaseModel,
  },

  props: ["handelModalApperance", "desc", "title"],

  emits: ["close"],
};
</script>
